import MM from "entity/Indicador/MM"
import TipoIndicador from ".."
import MManual from "entity/Indicador/MManual"

export default class ColheitaMuda extends TipoIndicador {
    static get fullName() {
        return "Colheita de Muda"
    }

    static get abbrev() {
        return "CM"
    }

    static get field() {
        return "colheitaMuda"
    }

    static get indicadores() {
        return [MM, MManual]
    }
}
